"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putDriverData = void 0;
/**
 * Upsert a driver's device data, such as the Health Check, from a driver's phone.
 */
var putDriverData = function (instance) {
    return function (body, config) {
        return instance.put("/vehicles/drivers/data", body, config);
    };
};
exports.putDriverData = putDriverData;
